/**
 * reducers/sources.js
 * desc: client sources
 * note: connects to third-party systems via YM endpoints
 *       hierarchy = sources -> directories -> messages
 */
'use strict';

import { formatDirectoriesPayload } from '../../utilities/directories';

const INITIAL_STATE = {
    isLoading: {
        createSource: false,
        deleteSource: false,
        deleteSourcesUploadFile: false,
        getAttachment: false,
        getDirectories: false,
        getMessage: false,
        getMessages: false,
        getSource: false,
        getSourceUsage: false,
        getSources: false,
        getUploadFiles: false,
        getUploadFile: false,
        updateDirectory: false,
        updateMessage: false,
        updateSource: false,
        uploadFile: false
    },
    directoryDetail: {},
    directoryList: [],
    messageDetail: {},
    messageList: {},
    sourceDetail: {},
    sourceUsage: [],
    sourceList: [],
    uploadFiles: []
};


function sourcesReducer(state=INITIAL_STATE, action) {
    switch (action.type) {
        // Clear Sources
        case 'CLEAR_SOURCES':
            return _clearSources();

        // Clear Messages
        case 'CLEAR_MESSAGES':
            return _clearMessages(state);

        // Clear Messages
        case 'CLEAR_MESSAGE':
            return _clearMessage(state);

        // CREATE Source (Instance)
        case 'CREATE_SOURCE_ERROR':
            return _createSourceError(state);
        case 'CREATE_SOURCE_REQUEST':
            return _createSourceRequest(state);
        case 'CREATE_SOURCE_SUCCESS':
            return _createSourceSuccess(state, action.payload);

        // CREATE Source Upload File (Instance)
        case 'CREATE_SOURCES_UPLOAD_FILE_ERROR':
            return _createSourceUploadFileError(state);
        case 'CREATE_SOURCES_UPLOAD_FILE_REQUEST':
            return _createSourceUploadFileRequest(state);
        case 'CREATE_SOURCES_UPLOAD_FILE_SUCCESS':
            return _createSourceUploadFileSuccess(state, action.payload);

        // DELETE Source (Instance)
        case 'DELETE_SOURCE_ERROR':
            return _deleteSourceError(state);
        case 'DELETE_SOURCE_REQUEST':
            return _deleteSourceRequest(state);
        case 'DELETE_SOURCE_SUCCESS':
            return _deleteSourceSuccess(state, action.payload);

        // DELETE Sources Upload File (Instance)
        case 'DELETE_SOURCES_UPLOAD_FILE_ERROR':
            return _deleteSourcesUploadFileError(state);
        case 'DELETE_SOURCES_UPLOAD_FILE_REQUEST':
            return _deleteSourcesUploadFileRequest(state);
        case 'DELETE_SOURCES_UPLOAD_FILE_SUCCESS':
            return _deleteSourcesUploadFileSuccess(state, action.payload);

        // GET Attachment (Instance)
        case 'GET_ATTACHMENT_ERROR':
            return _getAttachmentError(state);
        case 'GET_ATTACHMENT_REQUEST':
            return _getAttachmentRequest(state);
        case 'GET_ATTACHMENT_SUCCESS':
            return _getAttachmentSuccess(state);

        // GET Directories (Collection)
        case 'GET_DIRECTORIES_ERROR':
            return _getDirectoriesError(state);
        case 'GET_DIRECTORIES_REQUEST':
            return _getDirectoriesRequest(state);
        case 'GET_DIRECTORIES_SUCCESS':
            return _getDirectoriesSuccess(state, action.payload);

        // GET Message (Instance)
        case 'GET_MESSAGE_ERROR':
        case 'GET_TRIP_MESSAGE_ERROR':
            return _getMessageError(state);
        case 'GET_MESSAGE_REQUEST':
        case 'GET_TRIP_MESSAGE_REQUEST':
            return _getMessageRequest(state);
        case 'GET_MESSAGE_SUCCESS':
        case 'GET_TRIP_MESSAGE_SUCCESS':
            return _getMessageSuccess(state, action);

        // GET Message Internal (Instance)
        case 'GET_MESSAGE_INTERNAL_ERROR':
            return _getMessageInternalError(state);
        case 'GET_MESSAGE_INTERNAL_REQUEST':
            return _getMessageInternalRequest(state);
        case 'GET_MESSAGE_INTERNAL_SUCCESS':
            return _getMessageInternalSuccess(state, action.payload);

        // GET Messages (Collection)
        case 'GET_MESSAGES_ERROR':
            return _getMessagesError(state);
        case 'GET_MESSAGES_REQUEST':
            return _getMessagesRequest(state);
        case 'GET_MESSAGES_SUCCESS':
            return _getMessagesSuccess(state, action);

        // GET Source (Instance)
        case 'GET_SOURCE_ERROR':
            return _getSourceError(state);
        case 'GET_SOURCE_REQUEST':
            return _getSourceRequest(state);
        case 'GET_SOURCE_SUCCESS':
            return _getSourceSuccess(state, action.payload);

        // GET Source Usage (Instance)
        case 'GET_SOURCE_USAGE_ERROR':
            return _getSourceUsageError(state);
        case 'GET_SOURCE_USAGE_REQUEST':
            return _getSourceUsageRequest(state);
        case 'GET_SOURCE_USAGE_SUCCESS':
            return _getSourceUsageSuccess(state, action.payload);

        // GET Sources (Collection)
        case 'GET_SOURCES_ERROR':
            return _getSourcesError(state);
        case 'GET_SOURCES_REQUEST':
            return _getSourcesRequest(state);
        case 'GET_SOURCES_SUCCESS':
            return _getSourcesSuccess(state, action.payload);

        // GET Upload Files (List)
        case 'GET_SOURCES_UPLOAD_FILES_ERROR':
            return _getSourcesUploadFilesError(state);
        case 'GET_SOURCES_UPLOAD_FILES_REQUEST':
            return _getSourcesUploadFilesRequest(state);
        case 'GET_SOURCES_UPLOAD_FILES_SUCCESS':
            return _getSourcesUploadFilesSuccess(state, action.payload);

        // GET Upload Files (Instance)
        case 'GET_SOURCES_UPLOAD_FILE_ERROR':
            return _getSourcesUploadFileError(state);
        case 'GET_SOURCES_UPLOAD_FILE_REQUEST':
            return _getSourcesUploadFileRequest(state);
        case 'GET_SOURCES_UPLOAD_FILE_SUCCESS':
            return _getSourcesUploadFileSuccess(state, action.payload);

        // RESET Message (Instance)
        case 'RESET_MESSAGE_SELECTION':
            return _resetMessageSelection(state);

        // UPDATE Directory (Instance)
        case 'UPDATE_DIRECTORY_SELECTION':
            return _updateDirectorySelection(state, action.payload);

        // UPDATE Message (Instance)
        case 'UPDATE_MESSAGE_ERROR':
            return _updateMessageError(state);
        case 'UPDATE_MESSAGE_REQUEST':
            return _updateMessageRequest(state);
        case 'UPDATE_MESSAGE_SUCCESS':
            return _updateMessageSuccess(state, action);

        // Update Source (Instance)
        case 'UPDATE_SOURCE_ERROR':
            return _updateSourceError(state);
        case 'UPDATE_SOURCE_REQUEST':
            return _updateSourceRequest(state);
        case 'UPDATE_SOURCE_SUCCESS':
            return _updateSourceSuccess(state, action.payload);

        default:
            return state;
    }
};



//*************************************************
//*****   Clear Sources   *************************
//*************************************************
function _clearSources() {
    return INITIAL_STATE;
};



//*************************************************
//*****   Clear Messages   ************************
//*************************************************
function _clearMessages(state) {
    return {
        ...state,
        messageDetail: {},
        messageList: {},
    };
};



//*************************************************
//*****   Clear Message   *************************
//*************************************************
function _clearMessage(state) {
    return {
        ...state,
        messageDetail: {}
    };
};



//*************************************************
//*****   CREATE Source (Instance)   **************
//*************************************************
function _createSourceError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createSource: false,
        },
    };
};

function _createSourceRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createSource: true,
        },
    };
};

function _createSourceSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createSource: false,
        },
        sourceList: [ ...state.sourceList, payload ],
    };
};



//*************************************************
//*****   CREATE Source Upload File (Instance)   **
//*************************************************
function _createSourceUploadFileError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            uploadFile: false,
        },
    };
};

function _createSourceUploadFileRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            uploadFile: true,
        },
    };
};

function _createSourceUploadFileSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            uploadFile: false,
        },
        uploadFiles: [ ...state.uploadFiles, payload ],
    };
};



//*************************************************
//*****   DELETE Source (Instance)   **************
//*************************************************
function _deleteSourceError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSource: false,
        },
    };
};

function _deleteSourceRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSource: true,
        },
    };
};

function _deleteSourceSuccess(state, sourceId) {
    // create new list without deleted source
    let [ ...sourcesList ] = state.sourceList;
    const deletedIndex = state.sourceList.findIndex(x => x?.id === sourceId);
    if (deletedIndex > -1) sourcesList.splice(deletedIndex, 1);

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSource: false,
        },
        sourceList: sourcesList,
    };
};



//*************************************************
//***   DELETE Sources Upload File (Instance)   ***
//*************************************************
function _deleteSourcesUploadFileError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSourcesUploadFile: false,
        },
    };
};

function _deleteSourcesUploadFileRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSourcesUploadFile: true,
        },
    };
};

function _deleteSourcesUploadFileSuccess(state, { uploadFileId }) {
    // create new list without deleted source directory
    let [ ...directoryList ] = state.directoryList;
    let [ ...uploadFiles ] = state.uploadFiles;
    const deletedDirectoryIndex = state.directoryList.findIndex(x => x?.id === uploadFileId);
    const deletedUploadFileIndex = state.uploadFiles.findIndex(x => x?.id === uploadFileId);
    if (deletedDirectoryIndex > -1) directoryList.splice(deletedDirectoryIndex, 1);
    if (deletedUploadFileIndex > -1) uploadFiles.splice(deletedUploadFileIndex, 1);

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteSourcesUploadFile: false,
        },
        directoryList: directoryList,
        uploadFiles: uploadFiles
    };
};



//*************************************************
//*****   GET Attachment (Instance)   *************
//*************************************************
function _getDirectoriesError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getDirectories: false,
        },
    };
};

function _getDirectoriesRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getDirectories: true,
        },
        directoryList: []
    };
};

function _getDirectoriesSuccess(state, payload) {
    let directorySelection = {};

    // we need to change the format of initial payload to make the subdirectories nested inside of other subdirectories, to be on the same level
    const formattedDirectories = formatDirectoriesPayload(payload);

    // select defaultDirectory or fallback to first item
    if (payload.length) {
        const defaultDirectory = payload.find(x => x.name === 'All Open Cases' || x.name === 'Inbox');
        directorySelection = defaultDirectory || payload[0];
    }

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getDirectories: false,
        },
        directoryDetail: directorySelection,
        directoryList: formattedDirectories,
    };
};



//*************************************************
//*****   GET Directories (Collection)   **********
//*************************************************
function _getAttachmentError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getAttachment: false,
        },
    };
};

function _getAttachmentRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getAttachment: true,
        },
    };
};

function _getAttachmentSuccess(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getAttachment: false,
        },
    };
};



//*************************************************
//*****   GET Message (Instance)   ****************
//*************************************************
function _getMessageError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: false,
        },
    };
};

function _getMessageRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: true,
        },
    };
};

function _getMessageSuccess(state, action) {
    const { directoryId, payload } = action;

    // enrich message object w directory index
    // note: this is the pointer index for pagination and prev/next button
    const messages = state.messageList[directoryId]?.list || [];
    payload.index = messages.findIndex(x => x?.id === payload.id);

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: false,
        },
        messageDetail: payload,
    };
};



//*************************************************
//*****   GET Message Internal (Instance)   *******
//*************************************************
function _getMessageInternalError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: false,
        },
    };
};

function _getMessageInternalRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: true,
        },
    };
};

function _getMessageInternalSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessage: false,
        },
        messageDetail: payload,
    };
};



//*************************************************
//*****   GET Messages (Collection)   ************
//*************************************************
function _getMessagesError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessages: false,
        },
    };
};

function _getMessagesRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessages: true,
        },
    };
};

function _getMessagesSuccess(state, action) {
    const { directoryId, payload } = action;
    let resultMessages = [];

    if (state.messageList[directoryId]?.list && payload.page.pageNumber !== 0) {
        resultMessages = [ ...state.messageList[directoryId].list ];
        const startIndex = (payload.page.pageNumber * payload.page.pageSize);
        resultMessages.splice(startIndex, payload.customerMessages.length, ...payload.customerMessages);
    } else {
        resultMessages = payload.customerMessages;
        resultMessages.length = payload.page.totalElements;
    }

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getMessages: false,
        },
        messageList: {
            ...state.messageList,
            [directoryId]: {
                list: resultMessages,
                page: payload.page,
            }
        },
    };
};



//*************************************************
//*****   GET Source (Instance)   *****************
//*************************************************
function _getSourceError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSource: false,
        },
    };
};

function _getSourceRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSource: true,
        },
    };
};

function _getSourceSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSource: false,
        },
        sourceDetail: payload
    };
};



//*************************************************
//*****   GET Source Usage (Instance)   ***********
//*************************************************
function _getSourceUsageError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSourceUsage: false,
        },
    };
};

function _getSourceUsageRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSourceUsage: true,
        },
    };
};

function _getSourceUsageSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSourceUsage: false,
        },
        sourceUsage: payload
    };
};



//*************************************************
//*****   GET Sources (Collection)   *************
//*************************************************
function _getSourcesError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSources: false,
        },
    };
};

function _getSourcesRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSources: true,
        },
    };
};

function _getSourcesSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getSources: false,
        },
        sourceList: payload,
    };
};



//*************************************************
//*****   GET Upload Files (Collection)   *********
//*************************************************
function _getSourcesUploadFilesError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFiles: false,
        },
    };
};

function _getSourcesUploadFilesRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFiles: true,
        },
    };
};

function _getSourcesUploadFilesSuccess(state, payload) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFiles: false,
        },
        uploadFiles: payload,
    };
};



//*************************************************
//*****   GET Upload File (Instance)   ************
//*************************************************
function _getSourcesUploadFileError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFile: false,
        },
    };
};

function _getSourcesUploadFileRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFile: true,
        },
    };
};

function _getSourcesUploadFileSuccess(state, payload) {
    let [ ...uploadFiles ] = state.uploadFiles;
    const updatedIndex = state.uploadFiles.findIndex(x => x?.id === payload.id);
    if (updatedIndex > -1) {
        uploadFiles[updatedIndex] = payload;
    }
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getUploadFile: false,
        },
        uploadFiles: uploadFiles,
    };
};



//*************************************************
//*****   RESET Message (Instance)   **************
//*************************************************
function _resetMessageSelection(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateSource: false,
            getMessage: false,
        },
    };
};



//*************************************************
//*****   UPDATE Source (Instance)   **************
//*************************************************
function _updateSourceError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateSource: false,
        },
    };
};

function _updateSourceRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateSource: true,
        },
    };
};

function _updateSourceSuccess(state, payload) {
    // create new list w updated source
    let [ ...sourcesList ] = state.sourceList;
    const updatedIndex = state.sourceList.findIndex(x => x?.id === payload.id);
    if (updatedIndex > -1) {
        sourcesList[updatedIndex] = payload;
    }

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateSource: false,
        },
        sourceDetail: payload,
        sourceList: sourcesList,
    };
};


//*************************************************
//*****   UPDATE Directory (Instance)   ***********
//*************************************************
function _updateDirectorySelection(state, payload) {
    // update directory selection
    // note: payload is the updated directoryId string
    const newSelection = state.directoryList.find(x => x?.id === payload);

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateDirectory: false,
        },
        directoryDetail: newSelection || state.selection,
    };
};



//*************************************************
//*****   UPDATE Message (Instance)   *************
//*************************************************
function _updateMessageError(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateMessage: false,
        },
    };
};

function _updateMessageRequest(state) {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateMessage: true,
        },
    };
};

function _updateMessageSuccess(state, action) {
    const { directoryId, payload } = action;
    const messages = structuredClone(state.messageList[directoryId] && state.messageList[directoryId].list || []);
    const index = messages.findIndex(x => x?.id === payload.id);

    // add index to payload
    payload.index = index;

    // replace existing message w new payload
    // note: this will now include the latest intents updates
    messages[index] = payload;

    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            updateMessage: false,
        },
        messageDetail: payload,
        messageList: {
            ...state.messageList,
            [directoryId]: {
                ...state.messageList[directoryId],
                list: messages
            }
        }
    };
};



export default sourcesReducer;
